import { colors } from '../foundation';

type Props = {
  strokeWidth?: number;
  color:
    | (typeof colors.monochrome)['6']
    | (typeof colors.monochrome.inverse)['6']
    | (typeof colors.monochrome.inverse)['2']
    | (typeof colors.red)['100']
    | (typeof colors.red)['25'];
};

const ChevronRight = ({ color, strokeWidth = 1 }: Props) => {
  return (
    <svg width="28" height="20" viewBox="0 0 28 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.4583 2.91666L17.5416 9.99999L10.4583 17.0833"
        stroke={color}
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeWidth={strokeWidth}
      />
    </svg>
  );
};
export default ChevronRight;
